import { render } from "./SalaryInformationEdit.vue?vue&type=template&id=4177837f"
import script from "./SalaryInformationEdit.vue?vue&type=script&lang=js"
export * from "./SalaryInformationEdit.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueProject\\Cigl-Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__